
import {
  FETCH_CITY_REQUEST,
  FETCH_CITY_SUCCESS,
  FETCH_CITY_FAILURE,
  SET_SELECTED_CITY,
  CLEAR_CITY_LIST,
} from '../types';
import axios from '../../API/axios';

export const fetchCityData = (searchTerm="",pageNumber=1, pageSize= 5000) => async (dispatch) => {
   
  // Dispatch the request action
  dispatch({ type: FETCH_CITY_REQUEST });

  try {
    // API call to fetch city data
    const response = await axios.post(
      `/MasterData/GetCitiesDDL?Search=${searchTerm}&CountryName=India`,{
          pageNumber,
          pageSize,
      }
    );
//console.log("City Check===>",response.data.responseData.citiesDDL)
    // Map response data to desired structure
    const cityList = response.data.responseData.citiesDDL.map((val) => ({
      value: val.id,
      label: val.name,
    }));

    // Dispatch success action with city list payload
    dispatch({
      type: FETCH_CITY_SUCCESS,
      payload: cityList,
    });
  } catch (error) { 
    dispatch({
      type: FETCH_CITY_FAILURE,
      payload: error.message || 'Something went wrong while fetching city data',
    });
  }
};

export const selectCity = (cityId) => ({
  type: SET_SELECTED_CITY,
  payload: cityId,
});

export const clearCityList = () => ({
  type: CLEAR_CITY_LIST,
});